
  <ng-container>
    <div mat-dialog-title>
      <h2>{{"restaurant.Set No Show Policy" | translate}}</h2>
      <button mat-icon-button class="close" (click)="openConfirmDialog()">
        <mat-icon class="pop-close">close</mat-icon>
      </button>
    </div>
    <form [formGroup]="formGroup">
      <mat-dialog-content class="pt-0 pb-0">
        <div class="mat-dialog-body">
          <div class="fields-group">
            <mat-form-field class="mb-2" hideRequiredMarker>
              <mat-label>{{"restaurant.Refund Amount" | translate}}</mat-label>
              <input matInput formControlName="amount" >
              <p matSuffix class="font-20">%</p>
              <mat-error *ngIf="hasError('amount', 'required')">{{ 'forms.Required' | translate }}</mat-error>
              <mat-error *ngIf="hasError('amount', 'pattern') || hasError('amount', 'max')">
                  {{ 'forms.Invalid value' | translate }}
                </mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
        <!-- [disabled]="loading" [class.loading]="loading" *ngIf="isUpdate" -->
        <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
          {{"forms.Save" | translate}}
        </button>
      </mat-dialog-actions>
    </form>
  </ng-container>
